import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import httpNoPortal from 'hub-http/clients/noPortalApiClient';
export const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const rpcClientNoPortal = createRpcClientV2({
  hubHttpClient: httpNoPortal
});